import Tab from "@/components/Tab";
import DailyReservationList from "@/pages/Home/components/DailyReservationList";
import VehicleDailyReservationList from "@/pages/Home/components/VehicleDailyReservationList";

const RightPanel = () => {
  return (
    <div className="w-full rounded-lg border border-gray-light bg-white px-4 pb-4 shadow-sm">
      <Tab variant="underlined">
        <Tab.Item label="장소 예약">
          <DailyReservationList />
        </Tab.Item>
        <Tab.Item label="차량 예약">
          <VehicleDailyReservationList />
        </Tab.Item>
      </Tab>
    </div>
  );
};

export default RightPanel;
